import React from "react";
import './pr-button.scss';

export default class PrButtonComponent extends React.Component {

    render(){
        if(this.props.type.includes('linkFree')){
            return (<div className={`btn ${this.props.type}`} >
                <span className="extra-title--h5">{this.props.content}</span>
            </div>)
        }
        if(!this.props.type.includes('linkFree')){
            return (
                <a href={this.props.link} className={`btn ${this.props.type}`} data-action="click" data-category={this.props.category} data-label={this.props.label} data-value={this.props.value}>
                    <span className="extra-title--h5">{this.props.content}</span>
                </a>
            )
        }
    }
}
